import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class JsonSerialisationService {

  tryDeserialise<T>(s: string): T {
    try { return JSON.parse(s) as T; }
    catch { return null; }
  }

  trySerialise<T>(o: T): string {
    try { return JSON.stringify(o); }
    catch { return null; }
  }
}
